<style>
	.bg222 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar4{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;  }
.tabbar4 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar4 span.pos{  padding:0 1vw;}
.tabbar4 span.floder{ color:#666;}
 
.tabbar4 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
  
.table_key{margin:0;padding:0;overflow:hidden;width:24vw;margin-left:37vw;min-height:45vw;margin-top:10vw;position:relative;} 
.table_key span.hd{display:block;margin:0 auto;font-size:1.4vw;font-weight:bold;color:#333;text-align:center;}
.table_line{width:100%;height:3vw;border:#ededed solid 1px;border-radius:.5vw;margin-top:1vw;position:absolute;box-sizing:border-box;}
.table_line span.tab1{display:block;height:2.4vw;line-height:2.4vw;margin-top:.3vw;font-size:1.1vw;width:5vw;text-align:center;float:left;
border-right:#ededed solid 1px;color:#999;}
.table_line span.tab2{display:block;height:2.4vw;line-height:2.4vw;margin-top:.3vw;font-size:1.1vw;width:10vw;text-align:left;float:left;
color:#000;margin-left:1vw;}
.table_line img{display:block;float:right;width:1.2vw;margin-top:.9vw;margin-right:.5vw;}

.table_line input{display:block;height:2.4vw;line-height:2.4vw;margin-top:.3vw;font-size:1.1vw;width:16vw;text-align:left;float:left;
color:#000;margin-left:1vw;border:0;outline:none;}



.xxiala{position:absolute;top:5.85vw;background:#fff;width:19vw;left:5vw;border:#ddd solid 1px;border-top:0;z-index:99999;box-sizing:border-box;
      max-height:12vw; overflow-x: hidden;border-radius:.5vw;}
.xxiala ul li{width:100%;height:3vw;line-height:3vw;text-align:center;border-bottom:#d9d9d9 dotted 1px;box-sizing:border-box;font-size:1.1vw;
  cursor:pointer;}
.xxiala ul li:last-child{border-bottom:0;}
.xxiala ul li:hover{background:#d6e7f9;}



.leibie{top:6vw;}
.xxiala2{top:10vw;}
.pici{top:10vw;}
.xxiala3{top:14vw;}
.dalei{top:14vw;}
.xxiala4{top:18vw;}
.diqu{top:18vw;}
.xxiala5{top:22vw;}
.mark{top:22vw;}

.key_btn{width:24vw;height:3vw;position:absolute;top:28vw;}
.key_btn button{display:block;height:3vw;border:0;background:none;outline:none;box-sizing:border-box;width:10vw;font-size:1.1vw;border-radius:.5vw;}
.key_btn button.key_btn_state1{float:left;border:#ddd solid 1px;background:#fff;color:#333;cursor:pointer;}
.key_btn button.key_btn_state1:hover{background:#eee;}
.key_btn button.key_btn_state2{float:right;background:#3465ff;color:#fff;cursor:pointer;}
.key_btn button.key_btn_state2:hover{float:right; background:#5476df;}

.progress{width:35vw;height:30vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd{width:100%;height:4vw;line-height:4vw;text-align:center;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}

.jd{width:190px;height:190px;margin-top:3vw; }
.msg3{width:100%;margin:0 auto;line-height:3vw;font-size:1.2vw;text-align:center;font-weight:bold;color:#333;margin-top:1vw;}

.fjd{width:10vw;height:13vw;margin:0 auto;margin-top:3vw; }
.fjd img{display:block;margin:0 auto;width:10vw;}
.fjd span{display:block;height:3vw;line-height:3vw;text-align:center;font-size:1.4vw;color:#32AD37;}
.msg4{width:20vw;height:4vw;margin:0 auto;}
.msg4 span{display:block;text-align:center;font-size:1.1vw;line-height:2vw;}
.msg4 span.ms41{color:#333;}
.msg4 span.ms42{color:#c00;}
.import_btn{width:16vw;height:3vw;margin:0 auto;margin-top:2vw;}
.import_btn button{display:block;width:7.5vw;height:3vw;outline:none;border:0;border-radius:.5vw;font-size:1vw;}
.import_btn button.a1{float:left;border:#d2d2d2 solid 1px;background:#fff;color:#666;}
.import_btn button.a2{float:right;background:#3465ff;color:#fff; }
 
</style>
 
<template>
	<div class="bg222">
		    <transition name="draw">
			   <div class="mengban" v-show="progress_show"></div>
	       </transition>
		    <transition name="draw">
	       <div class="progress" v-show="progress_show">
		      <div v-if="mode==1">
				  <div class="progress_hd">导入数据表</div>
				   <div class="jd">
					   <Progress
							  :transitionDuration="2000"
							  :radius="85"
							  :strokeWidth="10"
							  strokeColor="#3465ff"
							  :value="percent"
							>
						   
					  </Progress>
				  </div>
			      <div class="msg3">表格导入中，请稍后</div>
			  </div>
			  <div v-if="mode==2">
				  <div class="progress_hd">导入数据表</div>
				   <div class="fjd">
					    <img src="../../assets/images/fjd.png">
						<span>导入完成</span>
				  </div>
			      <div class="msg4"><span class="ms41">{{success}}条信息已导入</span><span class="ms42">{{failed}}条信息导入失败</span></div>
				  <div class="import_btn">
				     <button class="a1" @click="view_results()">查看结果</button>
					 <button class="a2" @click="send_results()">返回数据仓库</button>
				  </div>
			  </div>
		   </div>
	    </transition>
	
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="back()"  src="../../assets/images/home_icon.png">
			<div class="tabbar4">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">数据仓库</span>
			   <span class="rights"></span>
			   <span class="floder">导入数据表</span>
			   <span class="rights"></span>
			   <span class="floder">选择数据表关键信息</span>
			</div>
		 </div>
		  <div class="table_key">
		       <span class="hd">请选择数据表关键信息</span>
		       <div class="table_line" @click="xxiala(1)">
			      <span class="tab1">学年</span>
				  <span class="tab2">{{year}}</span>
				  <img  src="../../assets/images/xia.svg">
			   </div>
			   <transition name="draw">
				   <div class="xxiala" v-show="xxiala1">
					  <ul>
						 <li v-for="item in year_list" @click="select_year(item.year,item.id)">{{item.year}}</li>
					  </ul>
				   </div>
			   </transition>
			   
			   
			   <div class="table_line leibie" @click="xxiala(2)">
			      <span class="tab1">类别</span>
				  <span class="tab2">{{leibie}}</span>
				  <img  src="../../assets/images/xia.svg">
			   </div>
			   <transition name="draw">
				   <div class="xxiala xxiala2" v-show="xxiala2">
					  <ul>
						 <li v-for="item in zhao_list" @click="select_zhao(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			   
			   <div class="table_line pici" @click="xxiala(3)" >
			      <span class="tab1">批次</span>
				  <span class="tab2">{{pici}}</span>
				  <img src="../../assets/images/xia.svg">
			   </div>
			   <transition name="draw">
				   <div class="xxiala xxiala3" v-show="xxiala3">
					  <ul>
						 <li v-for="item in pici_list" @click="select_pi(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			   
			    <div class="table_line dalei" @click="xxiala(4)" >
			      <span class="tab1">大类</span>
				  <span class="tab2">{{dalei}}</span>
				  <img src="../../assets/images/xia.svg">
			   </div>
			   <transition name="draw">
				   <div class="xxiala xxiala4" v-show="xxiala4">
					  <ul>
						 <li v-for="item in lei_list" @click="select_lei(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			    <div class="table_line diqu" @click="xxiala(5)" >
			      <span class="tab1">地区</span>
				  <span class="tab2">{{area}}</span>
				  <img src="../../assets/images/xia.svg">
			   </div>
			   
			   <transition name="draw">
				   <div class="xxiala xxiala5" v-show="xxiala5">
					  <ul>
						 <li v-for="item in area_list" @click="select_area(item.region_name,item.id)">{{item.region_name}}</li>
					  </ul>
				   </div>
			   </transition>
			   <div class="table_line mark" >
			      <span class="tab1">备注</span>
				  
				  <input type="text" placeholder="请输入备注" v-model="mark">
			   </div>
			   <div class="key_btn">
		             <button class="key_btn_state1" @click="back()">取消</button>
					 <button class="key_btn_state2" @click="sure()">确定</button>
		       </div>
		  </div>
		 

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import Progress from "easy-circular-progress";
	export default {
	    components: {
		  u_center,
		   Progress
	    },
		data() {
			return {
				 year:2021,
				 year_list:[],
				 xxiala1:false,
				 xxiala2:false,
				 xxiala3:false,
				 xxiala4:false,
				 xxiala5:false,
				 leibie:"统招",
				 zhao_list:[],
				 pici:'本科批',
				 pici_list:[],
				 dalei:"普通类",
				 lei_list:[],
				 area:"全国",
				 area_list:[],
				 area_id:1,
				 progress_show:false,
				 mode:1,
				 token:"",
				 year_id:1,
				 zs_category_id:1,
				 grade_id:1,
				 category_id:1,
				 mark:"",
				 percent:0,
				 success:0,
				 failed:0,
				 res_id:"",
				 template:"",
			}
		},
		mounted() { 
		     let self=this;
		      var token= localStorage.getItem("token");
			  this.template = this.$utils.getUrlKey('template');
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_import_key();
			  }  
			 
			
		},
		methods: {
		   back(){
		      this.$router.push("/");  
		   },
		   view_results(){
		      if(this.res_id){
			     
				   this.$router.push("/view_results?id="+this.res_id);  
				 
			  }else{
			     this.$toast.center('请上传文件');
			  }
		   },send_results(){
		      if(this.res_id){
				   this.$router.push("/sms_list");  
			  }else{
			     this.$toast.center('请上传文件');
			  }
		   },
		    sure(){
			  this.progress_show=true;
			  this.mode=1;
			  this.uploadfiles();
			},uploadfiles(){
			    let self=this;
				var file=localStorage.getItem("file");
				var name=localStorage.getItem("name");
				if(!file){
				   self.$toast.center('请选择要上传的文件');
				   return;
				}
				if(!name){
				   name=file;
				} 
				axios.post(this.$api+'/message/import_excel', {
					   file:file,
					   name:name,
					   token:self.token,
					   area_id:self.area_id,
					   year_id:self.year_id,
					   zs_category_id:self.zs_category_id,
					   grade_id:self.grade_id,
					   category_id:self.category_id,
					   mark:self.mark
		       }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					   	 
                                       self.percent=100;
									   self.success=data.data.success;
									   self.res_id=data.data.res_id;
									   self.failed=data.data.failed;
									  
									   
									   setTimeout(function(){
								         self.mode=2;
					                   },3000);
									  

						 
				  }else{
						    self.$toast.center(data.msg)  ;
                            self.progress_show=false;
                            self.percent=0;							
				  } 
		       }).catch(function (error) {
			          
		       });

			   
			}, 
			get_import_key(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_import_key', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					  self.area_list=data.data.area;
                      self.lei_list=data.data.category_list;
                      self.pici_list=data.data.grade;	
                      self.zhao_list=data.data.zs_list;	
                      self.year_list=data.data.year_list;					  
				  } 
		      }).catch(function (error) {
			         
		      });
		    },
		    xxiala(id){
			  if(id==1){
			     this.xxiala1=!this.xxiala1;this.xxiala2=false;this.xxiala3=false;this.xxiala4=false;this.xxiala5=false;
			  }else if(id==2){
			     this.xxiala2=!this.xxiala2;this.xxiala1=false;this.xxiala3=false;this.xxiala4=false;this.xxiala5=false;
			  }else if(id==3){
			     this.xxiala3=!this.xxiala3;this.xxiala1=false;this.xxiala2=false;this.xxiala4=false;this.xxiala5=false;
			  }else if(id==4){
			     this.xxiala4=!this.xxiala4;this.xxiala1=false;this.xxiala2=false;this.xxiala3=false;this.xxiala5=false;
			  }else if(id==5){
			     this.xxiala5=!this.xxiala5;this.xxiala1=false;this.xxiala2=false;this.xxiala3=false;this.xxiala4=false;
			  }
			},select_year(year,id){
			  this.year=year;
			  this.xxiala1=false;
			  this.year_id=id;
			},select_zhao(zhao,id){
			  this.leibie=zhao;
			  this.xxiala2=false;
			  this.zs_category_id=id;
			},select_pi(pi,id){
			  this.pici=pi;
			  this.xxiala3=false;
			  this.grade_id=id;
			},select_lei(lei,id){
			  this.dalei=lei;
			  this.xxiala4=false;
			  this.category_id=id;
			},select_area(area,id){
			  this.area=area;
			  this.xxiala5=false;
			  this.area_id=id;
			}
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/import_key2.vue